import type { LegalSection } from './legal-section';

export const PRIVACY_RIGHTS: readonly LegalSection[] = [
  {
    title: '4. Análisis de ponderación del interés legítimo',
    body: `Debook ha realizado un LIA (Legitimate Interest Assessment) para garantizar que los intereses de la plataforma (construcción de base de datos B2B y prevención de fraude) no vulneran los derechos de los interesados. Disponible bajo solicitud.`,
  },
  {
    title: '5. Destinatarios de los datos',
    body: `Sus datos pueden ser comunicados a: Apify s.r.o. (scraping), ManyChat, Inc. (chatbot), Railway Corp. (alojamiento), Cloudflare, Inc. (seguridad), proveedores de procesamiento de pagos en USDC, y autoridades públicas en cumplimiento de obligaciones legales.`,
  },
  {
    title: '6. Transferencias internacionales',
    body: `Las transferencias fuera del EEE se realizan bajo el EU-US Data Privacy Framework o Cláusulas Contractuales Tipo aprobadas por la Comisión Europea, garantizando un nivel de protección equivalente.`,
  },
];
